enum Format {
  Default = '--',
  Json = 'Json',
  TonkeeperCsv = 'TonkeeperCsv',
  TelegramMarkdown = 'TelegramMarkdown',
}

export default Format;
